export const compactObject = obj => Object.fromEntries(
  Object.entries(obj).filter(([k, v]) => Array.isArray(v)
    ? v.length > 0
    : !!v || v === 0 || v === false),
)

export const pick = keys => d => Object.fromEntries(Object.entries(d).filter(([k, _]) => keys.includes(k)))

export const compactSymbolObject = obj => Object.fromEntries(
  Object.getOwnPropertySymbols(obj)
    .map(symbol => [symbol, obj[symbol]])
    .filter(
      ([_, v]) => Array.isArray(v)
        ? v.length > 0
        : !!v || v === 0 || v === false,
    ),
)

export const pickSymbols = symbols => obj => Object.fromEntries(
  Object.getOwnPropertySymbols(obj)
    .filter(symbol => symbols.includes(symbol))
    .map(symbol => [symbol, obj[symbol]]),
)

export const valuesOfSymbolObject = obj => Object.getOwnPropertySymbols(obj).map(symbol => obj[symbol])
